import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Progress } from 'reactstrap';
import { Grid } from '@material-ui/core'
import { isUndefined, isEmpty} from 'lodash'
import { sv } from "date-fns/locale";
import {format}  from 'date-fns';
import { withStyles } from '@material-ui/styles';
import compose from 'recompose/compose';
import { getUtfalldiagramBMByAfid,setofUpdatedashboardBokaTV } from 'actions'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardBokaTY} = accountsData
    const { UtfallBMdiagram,DashboardBokaFilterOption} = DashBoard;
    return {
        UtfallBMdiagram,DashboardBokaFilterOption,authUser,updatedashboardBokaTY
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUtfalldiagramBMByAfid: (Afid,userid,FilterOption) => dispatch(getUtfalldiagramBMByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboardBokaTV: () => dispatch(setofUpdatedashboardBokaTV()),
        dispatch
    };
}
const styles = theme => ({
    MainProgress: {
      backgroundColor: '#12585E !important',
      height:"2.4rem !important",
      borderRadius:"30px",
      [theme.breakpoints.down('sm')]: {
        height:"1.8rem !important",
      },
      [theme.breakpoints.up('md')]: {
        height:"2rem !important",
      },
      [theme.breakpoints.up('lg')]: {
        height:"1.6rem !important",
      },
      [theme.breakpoints.up('xl')]: {
        height:"2.4rem !important",
      },
    },    
    marginMobile: {
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingBottom: '8px',
        color: '#fff',
        marginTop: '2rem',
        [theme.breakpoints.up('sm')]: {
            marginTop: '0rem'
        },
        // [theme.breakpoints.up('md')]: {
        //     marginTop: '-1rem'
        // },
    }, 
    green: {
        backgroundColor: '#93F8B3 !importent',
    },
    teal: {
        backgroundColor: '#44D1C2',
      //   color:"#44D1C2",
    }
  });

class ProgresBarbudget extends Component {
    state={
        UtfallBMdiagram:{utfall:0,budget:100},
        DashboardBokaFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getUtfalldiagramBMByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })          
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getUtfalldiagramBMByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboardBokaTY) === 1){
            this.props.getUtfalldiagramBMByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
            this.props.setofUpdatedashboardBokaTV()
        }
        if(this.props.DashboardBokaFilterOption !== this.state.DashboardBokaFilterOption && !isEmpty(this.props.DashboardBokaFilterOption))
           {
                
            this.setState({done:false})
               this.props.getUtfalldiagramBMByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
               this.setState({
                DashboardBokaFilterOption:this.props.DashboardBokaFilterOption 
               }) 
           }
           if(!isUndefined(this.props.UtfallBMdiagram)){
            if(this.props.UtfallBMdiagram !== this.state.UtfallBMdiagram){
                this.setState({
                    UtfallBMdiagram:this.props.UtfallBMdiagram
                })
            }
        }
       }
    formatNumber=(number)=>{
        return `${(number).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`
    }

    render() {
        const { classes } = this.props;
        return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        className="px-3 py-1"
        // className={classes.marginMobile}
        >
        <Grid item xs={3}  className="px-2 text-white" style={{ alignSelf: 'flex-end' }}>
          {
              this.state.done === false?  
              <Skeleton variant="rectangular" height={40} width={100} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
              :
            parseInt(this.props.Flags.DashboardBokaFormat) === 0  ?
            <div style={{ fontSize: '1.2rem' }}>{this.state.UtfallBMdiagram.utfall} <span style={{ fontSize: '0.9rem' }}>st</span> </div>
            : ''
          }
          {/* <div style={{ fontSize: '1.2rem' }}>/ {this.state.UtfallBMdiagram.budget} <span style={{ fontSize: '0.9rem' }}>st</span></div> */}
        </Grid>
        <Grid item xs={6}>
        {
            this.props.isFrom === 1 ?
            <div className="text-center text-white d-flex align-items-center justify-content-center">
                <h2 style={{  margin: '0',fontSize:"1.2rem", marginRight: '1rem' }}><b><IntlMessages id="Meeting.Budget"/></b></h2>
                <p style={{  fontSize:"14px",textTransform:"capitalize"}}>({`${format(new Date(), 'MMMM', { locale: sv })}`})</p>
            </div>
            :
            <div className="text-center text-white pb-1">
                <h2 style={{  margin: '0',fontSize:"1.5rem" }}><b><IntlMessages id="Meeting.Budget"/></b></h2>
                <p style={{fontSize:"18px",textTransform:"capitalize"}}>{`${format(new Date(), 'MMMM', { locale: sv })}`}</p>
            </div>

        }
        </Grid>

        <Grid item xs={3}  className="px-2 text-white" style={{ textAlign: 'right', alignSelf: 'flex-end' }}>
          {/* <div style={{ fontSize: '1.2rem' }}>{this.state.UtfallBMdiagram.utfall} <span style={{ fontSize: '0.9rem' }}>st</span> </div> */}
          {
             this.state.done === false?  
             <Skeleton variant="rectangular" height={40} width={100} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
             :
            parseInt(this.props.Flags.DashboardBokaFormat) === 0 ?
            <div style={{ fontSize: '1.2rem' }}>/ {this.state.UtfallBMdiagram.budget} <span style={{ fontSize: '0.9rem' }}>st</span></div>
            : ''
          }
        </Grid>
        <Grid item xs={12} className="pt-1" style={{ position: 'relative' }}>
        {
                          this.state.done === false?  
                          <Skeleton variant="rectangular" height={40} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                          :  
        <Progress multi className={classes.MainProgress}>
            <Progress bar 
            // animated 
            style={{ backgroundColor: parseInt(this.state.UtfallBMdiagram.utfall)>=parseInt(this.state.UtfallBMdiagram.budget)? '#77ED9C' : '#44D1C2'}}
                value={parseInt(this.state.UtfallBMdiagram.utfall)} 
                max={parseInt(this.state.UtfallBMdiagram.utfall)>=parseInt(this.state.UtfallBMdiagram.budget)?parseInt(this.state.UtfallBMdiagram.utfall):parseInt(this.state.UtfallBMdiagram.budget)}

            >
            <p
           style={{fontSize:"1.3rem", fontWeight:"700", color: '#075A5F'}}
           > 
                {/* {parseInt(this.state.UtfallBMdiagram.utfall)}             */}
                {parseInt((this.state.UtfallBMdiagram.utfall/this.state.UtfallBMdiagram.budget)*100)}
            %
            </p>
            </Progress>
        </Progress> 
        }
      </Grid>
      </Grid>
            </div>
        );
    }
}

export default  compose(
    connect(
        mapStateToProps,mapDispatchToProps
    ),
    withStyles(styles)
    )(ProgresBarbudget);